import { Expose } from 'class-transformer';
import { ElementOptions } from './element-options';

export class SurveyMultipleSelectOptions extends ElementOptions {
  @Expose()
  value!: number;

  @Expose({ name: 'allow_custom_value' })
  allowCustomValue!: boolean;

  @Expose()
  customValue?: string | null;
}
